import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import useCustomSimplifiedForm from 'components/common/form/hooks/useCustomSimplifiedForm';
import toast from 'app/toast/index';
import { Toaster } from 'sonner';
import { TemplateFormComponent } from 'components/common/form/layout/ReactHookFormController';

export default function DevToastExample() {
    const form = useCustomSimplifiedForm({
        type: 'success',
        title: 'Message',
        description: 'Description',
        position: 'bottom-right',
    });

    const handleToastClick = () => {
        const type = form.form.hookFormGetValues('type');
        const title = form.form.hookFormGetValues('title');
        const desc = form.form.hookFormGetValues('description');
        const position = form.form.hookFormGetValues('position');
        toast(type, title, desc, { toasterId: position });
    };

    const positions = [
        { label: 'bottom-right', value: 'bottom-right' },
        { label: 'top-right', value: 'top-right' },
        { label: 'bottom-center', value: 'bottom-center' },
    ];

    return (
        <Stack sx={{ width: '400px' }} spacing={1}>
            <Box>
                Toast Example
                {positions.map((p) => {
                    let offset = {};
                    if (p.value == 'top-right') {
                        offset = { top: '60px' };
                    }
                    //@ts-ignore
                    return <Toaster id={p.value} offset={offset} position={p.value} key={p.value} />;
                })}
            </Box>
            <Box>
                <TemplateFormComponent
                    component={'FormRadioGroup'}
                    componentValues={[
                        { label: 'Success', value: 'success' },
                        { label: 'Info', value: 'info' },
                        { label: 'Error', value: 'error' },
                    ]}
                    elementProps={form}
                    name={'type'}
                />
            </Box>
            <Box>
                <TemplateFormComponent
                    component={'FormRadioGroup'}
                    componentValues={positions}
                    elementProps={form}
                    name={'position'}
                />
            </Box>
            <Box>
                <TemplateFormComponent elementProps={form} component={'FormText'} name="title" />
            </Box>
            <Box>
                <TemplateFormComponent elementProps={form} component={'FormText'} name="description" />
            </Box>
            <Box>
                <Button onClick={handleToastClick}>Show Toast Notification</Button>
            </Box>
        </Stack>
    );
}
